import type { Schema, ValidationError } from "yup"
import { validationMessages } from "./getErrorListFromValidationError"

/**
 * @memberof useValidateSchema
 * */
export const validateSchema = (formElement: HTMLFormElement | null, schema: Schema | null) => {
    if (!schema) throw new Error('Schema is not defined')
    if (!formElement) throw new Error('form not found')
    const form = new FormData(formElement)
    const formObject: Record<string, FormDataEntryValue> = {}
    form.forEach((value, key) => {
        formObject[key] = value
    })
    try {
        schema.validateSync(formObject, { abortEarly: false })
        return []
    } catch (error) {
        return validationMessages(error as ValidationError)
    }
}
